<template>
  <figure
    v-if="src"
    class="image-block"
    :class="layoutClass"
  >
    <img
      class="image-block__img"
      :src="src"
      :alt="alt"
    />
    <figcaption
      v-if="caption"
      class="image-block__caption"
    >
      {{ caption }}
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'AppImageBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    src() {
      return (this.data && (this.data.src || this.data.image || this.data.url)) || ''
    },
    alt() {
      return (this.data && this.data.alt) || (this.data && this.data.caption) || 'Изображение'
    },
    caption() {
      return (this.data && this.data.caption) || ''
    },
    layout() {
      const raw = (this.data && (this.data.layout || this.data.width)) || 'inset'
      return String(raw).toLowerCase() === 'wide' ? 'wide' : 'inset'
    },
    layoutClass() {
      return `image-block--${this.layout}`
    },
  },
}
</script>

<style scoped lang="scss">
.image-block {
  margin: 1.5em 0;
  padding: 0;

  &__img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 12px;
  }

  &__caption {
    margin-top: 10px;
    font-family: 'Circe', Arial, sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: #666;
    text-align: center;
  }
}
</style>
